"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WsDataBucket = exports.TopicJoinStatus = void 0;
const shared_utils_iso_1 = require("@wranggle/shared-utils-iso");
const eventemitter3_1 = __importDefault(require("eventemitter3"));
const interfaces_1 = require("../interfaces");
// todo: improve/simplify the join state.. started on the path of having client initiate all topic join/leave requests but switched directions. Will need cleanup.
//  (TopicJoinStatus, _checkIfReady stuff, _receivedInitialState, _isSubscribedToWsTopic)
var TopicJoinStatus;
(function (TopicJoinStatus) {
    TopicJoinStatus["NotSubscribed"] = "NotSubscribed";
    TopicJoinStatus["Working"] = "Working";
    TopicJoinStatus["Ready"] = "Ready";
    TopicJoinStatus["Error"] = "Error";
})(TopicJoinStatus = exports.TopicJoinStatus || (exports.TopicJoinStatus = {}));
// export enum WsDataBucketEvent {
//   DataBucketSyncAction = 'DataBucketSyncAction',
//   JoinStatusChange = 'JoinStatusChange',
//   StateChange = 'StateChange',
//   DataBucketReady = 'DataBucketReady',
// }
class WsDataBucket extends eventemitter3_1.default {
    constructor({ wsTopic, authorVarName }) {
        super();
        this._state = {};
        this._isSubscriptionDesired = true;
        this._isSubscribedToWsTopic = false;
        this._receivedInitialState = false;
        this._joinStatus = TopicJoinStatus.NotSubscribed;
        this._earlyArrivingActions = [];
        this._wsTopic = wsTopic;
        this._authorVarName = authorVarName;
    }
    stop() {
        this.setIsSubscriptionDesired(false);
        this.markDisconnected();
        this._state = undefined;
    }
    markDisconnected() {
        this._earlyArrivingActions = [];
        this._isSubscribedToWsTopic = false;
        this._receivedInitialState = false;
        const joinStatus = this.getTopicJoinStatus();
        if (joinStatus === TopicJoinStatus.Ready) { // need a way to stop join-in-progress. And maybe add: || joinStatus === TopicJoinStatus.Working
            this._setTopicJoinStatus(TopicJoinStatus.NotSubscribed);
        }
    }
    _processMessage(action) {
        if (!this.getIsSubscriptionDesired()) {
            console.warn('Ignoring unwanted command', action);
            return;
        }
        if (!action || !action.actionType) {
            console.warn('Ignoring invalid ClientReducerAction', action);
            return;
        }
        if (this._receivedInitialState && this._isSubscribedToWsTopic) {
            this._dispatchReducerAction(action);
        }
        else {
            this._earlyArrivingActions.push(action);
        }
    }
    initialDataReceived(initialStateAction) {
        this._dispatchReducerAction(initialStateAction, { silenceStateEvent: true }); // updates initially silent, then we emit state change and DataBucketReady after all previous messags have been applied
        while (this._earlyArrivingActions.length > 0) {
            const command = this._earlyArrivingActions.shift();
            this._dispatchReducerAction(command, { silenceStateEvent: true });
        }
        this._receivedInitialState = true;
        this._isSubscribedToWsTopic = true;
        this.emit(interfaces_1.WsDataBucketEvent.DataBucketReady, {
            authorVarName: this.getAuthorVarName(),
            wsTopic: this.getWsTopic(),
        });
        this._triggerStateChange();
        this._setTopicJoinStatus(TopicJoinStatus.Ready);
    }
    setAuthorVarName(val) {
        this._authorVarName = val;
    }
    getAuthorVarName() {
        return this._authorVarName;
    }
    _serverTopicSubscriptionResponse(isSubscribed) {
        this._isSubscribedToWsTopic = isSubscribed;
        // this._checkIfReady();
    }
    _setTopicJoinStatus(status, extraInfo) {
        this._joinStatus = status;
        this.emit(interfaces_1.WsDataBucketEvent.JoinStatusChange, {
            status,
            wsTopic: this.getWsTopic(),
            extraInfo,
        });
    }
    _dispatchReducerAction(action, opts) {
        if (!this._isSubscriptionDesired) {
            return;
        }
        const detail = _dataBucketSyncReducerWithDeltaDetails(this._state, action);
        detail.wsTopic = this.getWsTopic();
        this._state = detail.updatedState;
        if (!opts || !opts.silenceSyncDetailsEvent) {
            this.emit(interfaces_1.WsDataBucketEvent.DataBucketSyncAction, detail);
        }
        if (!opts || !opts.silenceStateEvent) {
            this._triggerStateChange();
        }
    }
    _triggerStateChange() {
        if (this._isSubscriptionDesired) {
            this.emit(interfaces_1.WsDataBucketEvent.StateChange, {
                state: this.getState(),
                authorVarName: this.getAuthorVarName(),
                wsTopic: this.getWsTopic(),
            });
        }
    }
    getState() {
        return this._state || {};
    }
    getTopicJoinStatus() {
        return this._joinStatus || TopicJoinStatus.NotSubscribed;
    }
    getIsSubscribed() {
        return this._isSubscribedToWsTopic;
    }
    getIsSubscriptionDesired() {
        return this._isSubscriptionDesired;
    }
    setIsSubscriptionDesired(val) {
        this._isSubscriptionDesired = val;
    }
    getWsTopic() {
        return this._wsTopic;
    }
    isReady() {
        return this._receivedInitialState && this._isSubscribedToWsTopic;
    }
}
exports.WsDataBucket = WsDataBucket;
function _dataBucketSyncReducerWithDeltaDetails(prevState, action) {
    const { actionType } = action || {};
    if (!actionType || !action.actionData) {
        console.error('Ignoring malformed dispatch action for dataBucket reducer', action);
    }
    const { eachEntryNeedsJsonParse } = action.actionMeta || {};
    let updatedState;
    if (actionType === interfaces_1.WsDataBucketSyncActionType.ResetStore) {
        updatedState = _parsedActionData(action.actionData, eachEntryNeedsJsonParse);
    }
    else if (actionType === interfaces_1.WsDataBucketSyncActionType.UpdateItems) {
        updatedState = Object.assign({}, prevState, _parsedActionData(action.actionData, eachEntryNeedsJsonParse));
    }
    else if (actionType === interfaces_1.WsDataBucketSyncActionType.SetItem) {
        const { key, value } = _parsedActionData(action.actionData, eachEntryNeedsJsonParse);
        updatedState = Object.assign(Object.assign({}, prevState), { [key]: value });
    }
    else if (actionType === interfaces_1.WsDataBucketSyncActionType.DeleteItems) {
        updatedState = Object.assign({}, prevState);
        const { actionData } = action;
        // note: I don't think the keys ever get stringified individually.. skipping the parse loop 
        (actionData.keys || []).forEach(key => {
            delete updatedState[key];
        });
    }
    else {
        console.error('Received unknown reducer action:', actionType, action.actionData);
        updatedState = prevState;
    }
    return { action, prevState, updatedState };
}
function _parsedActionData(actionData, eachEntryNeedsJsonParse) {
    if (!actionData || !eachEntryNeedsJsonParse) {
        return actionData;
    }
    Object.keys(actionData).forEach(k => {
        actionData[k] = shared_utils_iso_1.parsedJsonOrOrig(actionData[k]);
    });
    return actionData;
}
//# sourceMappingURL=ws-data-bucket.js.map